import PostLoader from "parent/src/js/base/Controllers/PostLoader";
import PostCards from "parent/src/js/base/Controllers/PostCards";
import Main from "~/js/Main";

class Blog {
	constructor() {
		/**
		 * @type {HTMLElement}
		 */
		this.container = window.document.querySelector(".post-list");
		if (this.container) {
			this.postLoader = new PostLoader(this.container, "post");
			this.container.addEventListener(PostLoader.LoadSuccess, this.onPostsLoad.bind(this));

			Main.Instance.postLoaders.add(this.postLoader);
		}
	}

	/**
	 * @param {Event} e
	 */
	onPostsLoad(e) {
		new PostCards(true);
	}
}

export default Blog;
